import React from 'react';

function Html({q}) {
    return (
        <div dangerouslySetInnerHTML={{__html: q.data.text}}></div>
    );
}

export default Html;